import * as atobPolyfill from 'atob';
import * as mediaTypes from './media-types';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/dom/ajax';
import 'rxjs/add/observable/from';
import 'rxjs/add/observable/throw';
import 'rxjs/add/observable/zip';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import * as URI from 'urijs';
import * as XMLResponseParsers from './XMLResponseParsers';
;
;
;
if (!global.hasOwnProperty('XMLHttpRequest')) {
    global.XMLHttpRequest = require('xhr2');
}
if (!global.hasOwnProperty('atob')) {
    global.atob = atobPolyfill;
}
var convertObjectToQueryString = function (inputObject) {
    var str = '';
    for (var key in inputObject) {
        if (!inputObject.hasOwnProperty(key) || typeof inputObject[key] === 'function') {
            continue;
        }
        if (typeof inputObject[key] === 'object') {
            str += convertObjectToQueryString(inputObject[key]);
        }
        else {
            str += key + '=' + encodeURIComponent(inputObject[key]) + '&';
        }
    }
    return str;
};
/**
 * WikipathwaysApiClient
 *
 * @param args
 */
var WikipathwaysApiClient = /** @class */ (function () {
    function WikipathwaysApiClient(_a) {
        var _b = _a === void 0 ? { baseIri: null, timeout: 10 * 1000 } : _a, baseIri = _b.baseIri, timeout = _b.timeout;
        this.SUPPORTED = mediaTypes.SUPPORTED;
        this.timeout = timeout;
        if (!baseIri) {
            var isBrowser = (typeof window !== 'undefined' && typeof document !== 'undefined');
            if (isBrowser) {
                var hostnameSplit = window.location.hostname.split('wikipathways.org');
                if (hostnameSplit[hostnameSplit.length - 1] === '') {
                    // user is on wikipathways.org or one of its subdomains
                    baseIri = window.location.origin + '/wpi/webservicetest/';
                    //baseIri = 'https://webservice.wikipathways.org/'; //this route will lose authentication
                    //					const subdomain = hostnameSplit[0];
                    //					if (['','www.'].indexOf(subdomain) > -1) {
                    //						// user is one wikipathways.org main site
                    //						baseIri = window.location.origin + '/wpi/webservicetest/';
                    //						//baseIri = 'https://webservice.wikipathways.org/'; //this route will lose authentication
                    //					} else {
                    //						// user is on a wikipathways.org subdomain (likely a test server).
                    //						// TODO what should the permanent IRI be for the test servers?
                    //						baseIri = window.location.origin + '/wpi/webservicetest/';
                    //					}
                }
                else {
                    baseIri = 'https://webservice.wikipathways.org/';
                }
            }
            else {
                baseIri = 'https://webservice.wikipathways.org/';
            }
        }
        this.baseIri = baseIri;
    }
    /**
     * getPathway
       * NOTE: this actually corresponds to the webservice method "getPathwayAs"
     *
     * @param args
     * @return An Observable with the requested data.
     */
    WikipathwaysApiClient.prototype.getPathway = function (_a) {
        var _b = _a === void 0 ? {
            identifier: undefined, version: 0, fileFormat: 'application/ld+json'
        } : _a, identifier = _b.identifier, version = _b.version, fileFormat = _b.fileFormat;
        if (!identifier) {
            throw new Error('Please provide identifier');
        }
        var mediaType = mediaTypes.REQUESTED_TO_IANA_FOR_PATHWAYS[fileFormat.toLowerCase()];
        var iri = URI(this.baseIri)
            .filename('getPathwayAs')
            .query({
            pwId: identifier,
            fileType: mediaTypes.IANA_TO_WP_API_BODY[mediaType],
            revision: version || 0,
            format: 'json'
        });
        var pathwayMetadata = {};
        pathwayMetadata['@id'] = 'http://identifiers.org/wikipathways/' + identifier;
        pathwayMetadata.version = version;
        var ajaxRequest = {
            url: iri.toString(),
            method: 'GET',
            responseType: 'json',
            timeout: this.timeout,
            crossDomain: true,
        };
        return Observable.ajax(ajaxRequest)
            .map(function (ajaxResponse) { return ajaxResponse.xhr.response; })
            .map(function (response) {
            return atob(response.data).toString();
        });
    };
    WikipathwaysApiClient.prototype.getPathwayInfo = function (identifier) {
        if (!identifier) {
            throw new Error('Please provide identifier');
        }
        var iri = URI(this.baseIri)
            .filename('getPathwayInfo')
            .query({
            pwId: identifier,
            format: 'json',
        });
        var ajaxRequest = {
            url: iri.toString(),
            method: 'GET',
            responseType: 'json',
            timeout: this.timeout,
            crossDomain: true,
        };
        return Observable.ajax(ajaxRequest)
            .map(function (ajaxResponse) { return ajaxResponse.xhr.response.pathwayInfo; })
            .map(function (pathwayInfo) {
            return {
                identifier: pathwayInfo.id,
                url: pathwayInfo.url,
                name: pathwayInfo.name,
                organism: pathwayInfo.species,
                version: pathwayInfo.revision,
            };
        });
    };
    //import 'rx-extra/add/operator/throughNodeStream';
    //import 'rx-extra/add/observable/fromNodeReadableStream';
    //const JSONStream = require('JSONStream');
    //  function listPathways1(args, responseType) {
    //    args = args || {};
    //
    //    var requestedFileFormat = args.fileFormat || 'application/ld+json';
    //
    //    var mediaType = REQUESTED_TO_IANA[
    //        requestedFileFormat.toLowerCase()];
    //
    //    if (mediaType !== 'application/ld+json' &&
    //          mediaType !== 'application/json') {
    //      throw new Error('Requested file format not recognized or not available.');
    //    }
    //
    //    var iri = URI(baseIri)
    //    .filename('listPathways')
    //    .query({
    //      format: mediaTypes.IANA_TO_WP_API_ENVELOPE[mediaType]
    //    });
    //
    //		const ajaxRequest: AjaxRequest = {
    //			url: iri.toString(),
    //			method: 'GET',
    //			responseType: 'text',
    //			timeout: this.timeout,
    //			crossDomain: true,
    //		};
    //		return Observable.ajax(ajaxRequest)
    //		.map((ajaxResponse): string => ajaxResponse.xhr.response)
    //    .throughNodeStream(JSONStream.parse('pathways.*'))
    //    .map(function(data) {
    //      var pathway = {
    //        '@context': [
    //          'https://wikipathwayscontexts.firebaseio.com/biopax.json',
    //          'https://wikipathwayscontexts.firebaseio.com/organism.json',
    //          {
    //            '@vocab': 'http://www.biopax.org/release/biopax-level3.owl#'
    //          }
    //        ],
    //        '@id': 'http://identifiers.org/wikipathways/' + data.id,
    //        db: 'wikipathways',
    //        identifier: data.id,
    //        name: data.name,
    //        webPage: data.url,
    //        version: data.revision,
    //        organism: data.species
    //      };
    //
    //      return pathway;
    //    });
    //  }
    WikipathwaysApiClient.prototype.listPathways = function () {
        var iri = URI(this.baseIri)
            .filename('listPathways')
            .query({
            format: 'json'
        });
        var ajaxRequest = {
            url: iri.toString(),
            method: 'GET',
            responseType: 'json',
            timeout: this.timeout,
            crossDomain: true,
        };
        return Observable.ajax(ajaxRequest)
            .map(function (ajaxResponse) { return ajaxResponse.xhr.response; })
            .mergeMap(function (x) {
            return Observable.from(x.pathways);
        })
            .map(function (data) {
            return {
                '@context': [
                    'https://wikipathwayscontexts.firebaseio.com/biopax.json',
                    'https://wikipathwayscontexts.firebaseio.com/organism.json',
                    {
                        '@vocab': 'http://www.biopax.org/release/biopax-level3.owl#'
                    }
                ],
                '@id': 'http://identifiers.org/wikipathways/' + data.id,
                db: 'wikipathways',
                identifier: data.id,
                name: data.name,
                webPage: data.url,
                version: data.revision,
                organism: data.species
            };
        });
    };
    /**
     * login
     *
     * @param args If user is visiting a WikiPathways MediaWiki instance via browser and
       * 						 is logged in, username and password are optional, because Nuno is
       * 						 using cookie-based authentication for the webservice for this case.
     * @return An Observable with a token that can be used to make protected requests.
     */
    WikipathwaysApiClient.prototype.login = function (_a) {
        var username = _a.username, password = _a.password;
        var iri = URI(this.baseIri)
            .filename('login')
            .query({
            name: username,
            pass: password,
            format: 'json',
        });
        var ajaxRequest = {
            url: iri.toString(),
            method: 'GET',
            responseType: 'json',
            timeout: this.timeout,
            crossDomain: true,
        };
        return Observable.ajax(ajaxRequest)
            .map(function (ajaxResponse) { return ajaxResponse.xhr.response; })
            .map(function (data) {
            if (!data.hasOwnProperty('auth')) {
                return Observable.throw(new Error('Login problem. No auth property on response body.'));
            }
            else {
                return data.auth;
            }
        });
    };
    WikipathwaysApiClient.prototype.updatePathway = function (_a) {
        var description = _a.description, username = _a.username, password = _a.password, identifier = _a.identifier, gpml = _a.gpml;
        var baseIri = this.baseIri;
        var gpmlHeader = '<?xml version="1.0" encoding="UTF-8"?>';
        var prefixedGpml = (gpml.indexOf(gpmlHeader) === 0 ? '' : gpmlHeader).concat(gpml);
        return Observable.zip(this.login({ username: username, password: password }), this.getPathwayInfo(identifier))
            .mergeMap(function (_a) {
            var loginResult = _a[0], pathwayInfo = _a[1];
            var iri = URI(baseIri)
                .filename('updatePathway');
            var ajaxRequest = {
                url: iri.toString(),
                method: 'POST',
                // 'document' appears to work in Chrome
                // and in Node.JS, but
                // RxJS4 doesn't support 'document', and
                // RxJS5 doesn't have good documentation
                // for accepted values here. The value
                // 'xml' also appeared to work, but there
                // was a warning saying it wasn't in the
                // enum of accepted values.
                // TODO be sure 'document' is correct and
                // works cross browser.
                responseType: 'document',
                timeout: this.timeout,
                crossDomain: true,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: convertObjectToQueryString({
                    pwId: identifier,
                    description: description,
                    revision: pathwayInfo.version,
                    gpml: prefixedGpml,
                    username: username,
                    auth: loginResult,
                }),
            };
            return Observable.ajax(ajaxRequest)
                .mergeMap(XMLResponseParsers.updatePathway)
                .map(function (response) {
                var status = response.status, statusText = response.statusText, message = response.message;
                var output = {
                    status: status,
                    statusText: statusText,
                };
                var outputStatus = output.status;
                if (200 <= outputStatus && outputStatus < 300) {
                    output.version = parseInt(message);
                }
                else {
                    output.error = message;
                }
                return output;
            });
        });
    };
    return WikipathwaysApiClient;
}());
export { WikipathwaysApiClient };
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/wikipathways-api-client.ts
// module id = 25
// module chunks = 0